module.exports = __webpack_public_path__ + "static/media/share.732962ac.png";